import { styled } from '@mui/system';
import { Typography, Stack } from '@mui/material';
import { ExtendedTypography } from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';

export type IndicatorProps = {
  title: string;
  value: number | undefined;
  color?: string;
  testId?: string;
};

export function Indicator(props: IndicatorProps) {
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <Stack justifyContent='flex-end' data-testid={props.testId}>
      <Stack direction='row' alignItems='center' flexGrow={1}>
        {props.color && <Bullet color={props.color} />}
        <ExtendedTypography
          variant='textMd'
          color={semantic.color.text.muted.value}
          textAlign='left'
        >
          {props.title}
        </ExtendedTypography>
      </Stack>
      <Typography
        fontSize={semantic.fontSize.title.lg.value}
        textAlign='center'
        data-testid='value'
      >
        {props.value}
      </Typography>
    </Stack>
  );
}

type BulletProps = {
  color: string;
};

const Bullet = styled('div')<BulletProps>`
  max-width: 12px;
  padding-right: 12px;
  margin-right: 4px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;
